/**
 * Вертикаль-специфичные UI-тексты страницы eSIM (ESimPageContent):
 * hero-CTA, заголовки/лиды секций, тексты квиз-баннера, нижний CTA и т.п.
 * Общие надзаголовки/якоря/теги берутся из общего namespace `servicePage` (sp.*).
 */
export const esimPage = {
    en: {
        leaf: 'eSIM',

        // hero
        heroCtaFallback: 'Find a plan',
        heroCompat: 'Check compatibility',
        heroQuiz: 'Pick a plan in a minute',

        // subnav anchors (vertical-specific labels)
        anchorScenarios: 'Scenarios',
        anchorPlans: 'Plans',
        anchorHow: 'How it works',
        anchorPromocodes: 'Promo codes',
        anchorArticles: 'Articles',

        // providers
        providersTitle: (forName) => `Verified eSIM${forName ? ' for ' + forName : ''}`,
        providersLead: 'eSIM providers for your trip: where to connect, what works, and what to watch for.',
        buy: 'Buy →',
        pick: 'Pick',
        from: 'from',
        showAllProviders: (n) => `Show all providers (${n})`,
        hideProviders: 'Show fewer providers',

        // quiz band
        quizEyebrow: "Not sure what to pick?",
        quizTitle: 'Find your eSIM plan in a minute',
        quizText: 'Answer a few questions about your trip and we will suggest a data plan and a couple of alternatives.',
        quizCta: 'Take the quiz →',

        // scenarios
        scenariosEyebrow: 'Scenarios',
        scenariosTag: 'by trip type',
        scenariosTitle: 'Plans for every occasion',
        scenariosLead: 'Choose the operator and package that fits your trip — from a weekend to several months.',
        scenarioCtaFallback: 'Show plans',

        // plans ledger
        plansEyebrow: 'Plans',
        plansTitle: 'Pick your data volume',
        plansLead: 'Compare operators by volume, validity and price per gigabyte. Toggle between local and regional coverage.',

        // how it works
        howTitle: 'How it works',
        howLead: 'From purchase to connection — four simple steps to be online from minute one.',

        // promo codes
        promosTitle: 'Promo codes',
        promosAllLabel: 'All promo codes',
        promosLead: 'Current discounts — tap “Show code” to copy the promo code.',

        // faq
        faqLead: 'A quick guide to eSIM activation, coverage and compatibility.',

        // articles
        articlesTitle: 'eSIM articles',
        articlesLead: 'Guides, comparisons and practical tips on staying connected while travelling.',

        // bottom CTA
        ctaEyebrow: 'Connected in minutes',
        ctaTitle: (inName) => `Get online${inName ? ' in ' + inName : ''} before you land.`,
        ctaBtn: 'Find a plan →',
    },
    ru: {
        leaf: 'eSIM',

        // hero
        heroCtaFallback: 'Подобрать тариф',
        heroCompat: 'Проверить совместимость',
        heroQuiz: 'Подобрать за минуту',

        // subnav anchors (vertical-specific labels)
        anchorScenarios: 'Сценарии',
        anchorPlans: 'Тарифы',
        anchorHow: 'Как это работает',
        anchorPromocodes: 'Промокоды',
        anchorArticles: 'Статьи',

        // providers
        providersTitle: (forName) => `Лучшие eSIM${forName ? ' для ' + forName : ''}`,
        providersLead: 'eSIM-провайдеры для поездки: где подключить, что работает и на что обратить внимание.',
        buy: 'Купить →',
        pick: 'Выбор',
        from: 'от',
        showAllProviders: (n) => `Показать всех провайдеров (${n})`,
        hideProviders: 'Свернуть список',

        // quiz band
        quizEyebrow: 'Не знаете, что выбрать?',
        quizTitle: 'Подберите тариф eSIM за минуту',
        quizText: 'Ответьте на несколько вопросов о поездке — получите подходящий пакет данных и пару альтернатив.',
        quizCta: 'Пройти подбор →',

        // scenarios
        scenariosEyebrow: 'Сценарии',
        scenariosTag: 'подбор под поездку',
        scenariosTitle: 'Тарифы на любой случай',
        scenariosLead: 'Выберите подходящего оператора и пакет под вашу поездку — от уик-энда до нескольких месяцев.',
        scenarioCtaFallback: 'Показать тарифы',

        // plans ledger
        plansEyebrow: 'Тарифы',
        plansTitle: 'Подберите объём данных',
        plansLead: 'Сравните операторов по объёму, сроку и цене за гигабайт. Переключайтесь между локальным и региональным покрытием.',

        // how it works
        howTitle: 'Как это работает',
        howLead: 'От покупки до подключения — четыре простых шага, чтобы быть онлайн с первой минуты.',

        // promo codes
        promosTitle: 'Промокоды',
        promosAllLabel: 'Все промокоды',
        promosLead: 'Актуальные скидки — нажмите «Показать код», чтобы скопировать промокод.',

        // faq
        faqLead: 'Коротко о подключении, покрытии и совместимости eSIM.',

        // articles
        articlesTitle: 'Статьи о eSIM',
        articlesLead: 'Разборы, сравнения и практические советы по мобильному интернету в путешествиях.',

        // bottom CTA
        ctaEyebrow: 'Подключение за пару минут',
        ctaTitle: (inName) => `Интернет${inName ? ' в ' + inName : ''} ещё до посадки.`,
        ctaBtn: 'Подобрать тариф →',
    },
};
